import React, { useState, useEffect, useCallback } from "react";

const ReportModal = ({ getReportOptions, apInstance, testAttemptId, domain }) => {
    const [isTrustScoreCalculated, setIsTrustScoreCalculated] = useState(false);

    const pollForTrustScore = useCallback(async () => {
        const testAttemptStatus = await fetchTestAttemptStatus();

        switch (testAttemptStatus) {
            case "trust_score_calculated":
                setIsTrustScoreCalculated(true);
                break;
            case "finished":
                document.getElementById("report-status").innerText = "Calculating Trust Score";
                document.getElementById("report-status-img").src = "https://cdn.autoproctor.co/sdk/img/pending.svg";
            default:
                // Poll again after 2 seconds
                setTimeout(pollForTrustScore, 2000);
        }
    }, []);

    useEffect(() => {
        if (!isTrustScoreCalculated) {
            // Start polling for trust score after 5 seconds
            setTimeout(pollForTrustScore, 5000);
        } else {
            // Trust score is calculated, render the report
            const reportOptions = getReportOptions();
            apInstance.showReport(reportOptions);
        }
    }, [pollForTrustScore, isTrustScoreCalculated]);

    async function fetchTestAttemptStatus() {
        try {
            const response = await fetch(
                `${domain}/api/v2/test-attempts/${apInstance?.testAttemptId}/?fields=test_attempt_status`,
                {
                    headers: {
                        Authorization: `Bearer ${apInstance?.jwtToken}`,
                    },
                }
            );
            const data = await response.json();
            return data?.test_attempt?.test_attempt_status;
        } catch (error) {
            console.error("Error fetching test attempt status: ", error);
        }
    }

    return (
        <div id="ap-report-modal" className={"fixed top-0 bottom-0 right-0 left-0  backdrop-blur z-50"}>
            {isTrustScoreCalculated ? (
                <div className="relative max-w-5xl h-[90%] top-[5%] mx-auto overflow-scroll bg-white border border-gray-300/30 text-black rounded">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6 absolute right-4 top-4 cursor-pointer"
                        onClick={() => {
                            document.getElementById("ap-report-modal").style.display = "none";
                        }}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <div className=" container mx-auto mt-8 max-w-5xl " id="ap-report__overview"></div>
                    <div className="container mx-auto mt-8 max-w-5xl" id="ap-report-tab-container"></div>
                </div>
            ) : (
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid place-content-center w-1/2 h-1/2 bg-white rounded-2xl">
                    <div className="w-full mx-auto">
                        <div className="flex flex-col items-center my-5">
                            <img
                                className="w-20 h-20"
                                id="report-status-img"
                                src="https://cdn.autoproctor.co/sdk/img/puzzle.svg"
                            />
                            <span id="report-status" className="text-blue-900 font-semibold text-lg pt-2">
                                {" "}
                                Generating Proctoring Report{" "}
                            </span>
                            <span className="text-gray-500 text-sm"> Please wait for around 20 seconds </span>
                        </div>
                    </div>

                    <div className="flex justify-center items-center mt-1 mx-auto">
                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-900"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReportModal;
